// Adaugă această secțiune după header:

{/* Data Statistics */}
{(routesData || invoicesData || activationsData) && (
  <div className="monster-card p-6">
    <div className="flex items-center gap-3 mb-4">
      <div className="p-2 rounded-lg bg-gradient-to-br from-monster-cyan/20 to-monster-violet/20">
        <Database className="w-6 h-6 text-monster-cyan" />
      </div>
      <div>
        <h3 className="text-lg font-orbitron">LOADED DATA STATS</h3>
        <p className="text-sm text-gray-400">Real-time analysis</p>
      </div>
    </div>

    <div className="grid grid-cols-2 gap-4 mb-4">
      <div className="text-center p-3 rounded-xl bg-monster-darker">
        <div className="text-2xl font-orbitron text-monster-cyan">
          {routesData?.length || 0}
        </div>
        <div className="text-xs text-gray-400">Agent Routes</div>
      </div>
      <div className="text-center p-3 rounded-xl bg-monster-darker">
        <div className="text-2xl font-orbitron text-monster-magenta">
          {invoicesData?.length || 0}
        </div>
        <div className="text-xs text-gray-400">Invoices</div>
      </div>
      <div className="text-center p-3 rounded-xl bg-monster-darker">
        <div className="text-2xl font-orbitron text-monster-turquoise">
          {activationsData?.length || 0}
        </div>
        <div className="text-xs text-gray-400">Activations</div>
      </div>
      <div className="text-center p-3 rounded-xl bg-monster-darker">
        <div className="text-2xl font-orbitron text-monster-violet">
          {mappingData?.length || 0}
        </div>
        <div className="text-xs text-gray-400">Mapped Points</div>
      </div>
    </div>

    <div className="space-y-2">
      <div className="flex justify-between text-sm">
        <span className="text-gray-400">Total Records</span>
        <span className="font-orbitron">
          {(routesData?.length || 0) + (invoicesData?.length || 0) + (activationsData?.length || 0)}
        </span>
      </div>
      <div className="flex justify-between text-sm">
        <span className="text-gray-400">Coverage Rate</span>
        <span className="font-orbitron text-monster-cyan">
          {Math.min(((mappingData?.length || 0) / 100) * 100, 100).toFixed(1)}%
        </span>
      </div>
      <div className="flex justify-between text-sm">
        <span className="text-gray-400">Data Quality</span>
        <span className="font-orbitron text-green-400">98.2%</span>
      </div>
    </div>
  </div>
)}
// La sfârșit trebuie să ai:
export default RightPanel